import { Inject, Injectable, InjectFlags } from '@angular/core';
import { DataService } from '@/core/services/data.service';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { MessageType } from './models/messageType';
import { Flag } from './models/flag';
import { FeeType } from './models/feeType';
import { HelpLink } from './models/helpLink';
import { PaginationRequest } from '@/core/core.barrel';
import { ProgramTypeService } from '@/programs/services/program-type.service';
import { StatusChangeReason } from './models/statusChangeReason';
import { SelectItem } from 'primeng/api';
import { map } from 'rxjs/operators';
import { LookupItem } from '@/shared/models/shared';
import { ChangeReasonsFilter } from './models/change-reasons';
import { MarketingContent, MarketingContentFilter } from './models/marketingContent';
import { isEmpty, toQuery } from "@/shared/classes/utils";

@Injectable({
  providedIn: 'root'
})
class MessageTypeService {

  constructor(private logger: NGXLogger, private http: DataService) { }

  getStaffUsers(): Observable<Object> {
    return this.http.get(`/user/staff`);
  }

  getMessageTypes(): Observable<Object> {
    return this.http.get('/messagetype');
  }

  deleteMessageType(id): Observable<Object> {
    return this.http.delete(`/messagetype/delete/${id}`);
  }

  saveMessageType(messageType: MessageType): Observable<Object> {
    return this.http.post(`/messagetype`, messageType);
  }
}

@Injectable({
  providedIn: 'root'
})
class FlagService {

  constructor(private logger: NGXLogger, private http: DataService) { }

  get(request: PaginationRequest): Observable<Object> {
    return this.http.get(`/flag?${PaginationRequest.toQuery(request)}`);
  }

  post(data: Flag): Observable<Object> {
    return this.http.post(`/flag`, data);
  }

  put(data: Flag): Observable<Object> {
    return this.http.put(`/flag/${data.id}`, data);
  }

  delete(id): Observable<Object> {
    return this.http.delete(`/flag/${id}`);
  }
}

@Injectable({
  providedIn: 'root'
})
class FeeTypeService {

  constructor(private logger: NGXLogger, private http: DataService) { }

  get(request: PaginationRequest): Observable<Object> {
    return this.http.get(`/feetype?${PaginationRequest.toQuery(request)}`);
  }

  post(data: FeeType): Observable<Object> {
    return this.http.post(`/feetype`, data);
  }

  put(data: FeeType): Observable<Object> {
    return this.http.put(`/feetype/${data.id}`, data);
  }

  delete(id): Observable<Object> {
    return this.http.delete(`/feetype/${id}`);
  }

  exists(programTypeid, netSuiteCode): Observable<Object> {
    return this.http.get(`/feetype/${programTypeid}/${netSuiteCode}`);
  }
}
@Injectable({
    providedIn:'root'
})
class ChangeReasonsService{
  constructor(private logger: NGXLogger, private http: DataService) { }
  get(request: PaginationRequest, filter: ChangeReasonsFilter): Observable<Object> {
    var url = `/setting/StatusChangeReason?${PaginationRequest.toQuery(request)}`;
    
    if (!isEmpty(filter)) {
      url += `&${toQuery(filter)}`;
    }

    return this.http.get(url);
  }

  post(data: StatusChangeReason): Observable<Object> {
    return this.http.post(`/setting/statusChangeReason`, data);
  }

  put(data: StatusChangeReason,id:number): Observable<Object> {
    return this.http.put(`/setting/StatusChangeReason/${id}`, data);
  }
  getLookup(lookupType: string, excluded?: Array<SelectItem>, sort: boolean = true): Observable<LookupItem[]> {
    return this.http.get(`/program/lookup/${lookupType}`).pipe(map((resp: Array<any>) => {
      if (sort) {
        resp.sort((a, b) => (a.label > b.label) ? 1 : -1);
      }
      
      if (!excluded) {
        return resp;
      }

      return resp.filter(x => excluded.filter(y => y.value == x.value).length == 0);
    }));
  }
}

@Injectable({
  providedIn: 'root'
})
class HelpLinkService {

  constructor(private logger: NGXLogger, private http: DataService) { }

  get(request: PaginationRequest): Observable<Object> {
    return this.http.get(`/helplink?${PaginationRequest.toQuery(request)}`);
  }

  post(data: HelpLink): Observable<Object> {
    return this.http.post(`/helplink`, data);
  }

  put(data: HelpLink): Observable<Object> {
    return this.http.put(`/helplink/${data.id}`, data);
  }

  delete(id): Observable<Object> {
    return this.http.delete(`/helplink/${id}`);
  }
}
@Injectable({
  providedIn: 'root'
})
class MarketingContentService {

  constructor(private logger: NGXLogger, private http: DataService) { }

  get(request: PaginationRequest, filter: MarketingContentFilter): Observable<Object> {
    let url = `/marketingcontent?${PaginationRequest.toQuery(request)}`;

    if (!isEmpty(filter)) {
      url += `&${toQuery(filter)}`;
    }

    return this.http.get(url);
  }

  getById(id: number): Observable<Object> {
    return this.http.get(`/marketingcontent/${id}`);
  }

  post(data: MarketingContent): Observable<Object> {
    return this.http.post(`/marketingcontent`, data);
  }

  put(data: MarketingContent): Observable<Object> {
    return this.http.put(`/marketingcontent/${data.id}`, data);
  }

  delete(id): Observable<Object> {
    return this.http.delete(`/marketingcontent/${id}`);
  }

  copy(id: number): Observable<Object> {
    return this.http.post(`/marketingcontent/${id}/copy`, {});
  }
}

export {
  MessageTypeService,
  FlagService,
  FeeTypeService,
  ProgramTypeService,
  ChangeReasonsService,
  HelpLinkService,
  MarketingContentService
}
